import couponcheck from '../views/couponsys/couponcheck'
import savethetrees from '../views/couponsys/savethetrees'
import dreamanddream from '../views/couponsys/dreamanddream'
import queenti from '../views/couponsys/queenti'

export default [
  {
    path: '/cp/couponcheck/:couponNo',
    name: '/cp/couponcheck',
    component: couponcheck
  },
  {
    path: '/cp/savethetrees',
    name: '/cp/savethetrees',
    component: savethetrees,
    props: true
  },
  {
    path: '/cp/dreamanddream',
    name: '/cp/dreamanddream',
    component: dreamanddream,
    props: true
  },
  {
    path: '/cp/queenti',
    name: '/cp/queenti',
    component: queenti,
    props: true
  }
]


// WEBPACK FOOTER //
// ./src/router/couponsys.js